import CellLoader from '../Cell/CellLoader';
import SlotCell from './SlotCell';

/**
 *
 */
export default class SlotCellLoader extends CellLoader {
    /**
     * @return {{name: string}}
     */
    vueComponent() {
        return SlotCell;
    }

    /**
     * @return {{}}
     */
    props() {
        return {
            appResource: this.config.appResource,
            slotName: this.config.slotName,
            loadingSlotName: this.config.loadingSlotName,
        };
    }
}
